export const grabSelectedRecipientKeys = (recipients, fullRecipientsList) => {
  const keys = [];
  if(recipients) {
    if(recipients[1] && recipients[1] === true) {
      fullRecipientsList.forEach((recipient, key) => {
        keys.push(key);
      });
    } else if (recipients[0] === true) {
      keys.push(0);
    }
  }
  return keys;
};



// WEBPACK FOOTER //
// ./src/lib/grabSelectedRecipientKeys.js